export function createGiftDismissalStore() {
 let dismissed=false;
 const listeners=new Set<()=>void>();
 return {
  getSnapshot:()=>dismissed,
  getServerSnapshot:()=>false,
  subscribe(listener:()=>void){listeners.add(listener);return()=>{listeners.delete(listener);};},
  dismiss(){if(dismissed)return;dismissed=true;listeners.forEach(listener=>listener());},
 };
}

// 문서 메모리만 사용해 경로 이동 중에는 숨김을 유지하고 새로고침에는 초기화합니다.
export const biteGiftDismissal=createGiftDismissalStore();
